import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IWorkflow } from "@common/interfaces/workflow";
import { ID } from '@common/interfaces/id';
import { ActiveState, EntityState, EntityStore } from "@datorama/akita";

export interface WorkflowState extends EntityState<IWorkflow, ID>, ActiveState { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.WORKFLOWS , realtimeEntity: 'Workflow'})
export class WorkflowStore extends EntityStore<WorkflowState> {

  constructor() {
    super([]);
  }
}
